(() => {
  "use strict";

  const userAgent = navigator.userAgent || "";
  const isAndroidWebView = /\bAndroid\b/i.test(userAgent) && /;\s?wv\)/i.test(userAgent);
  const isTikTokUserAgent = /\b(musical_ly|Bytedance|BytedanceWebview|trill|TikTok)(?:\b|_)/i.test(userAgent);
  const isTikTokReferrer = /\b(tiktok|musical\.ly)\.com\b/i.test(document.referrer || "");
  const isTikTokAndroid = /\bAndroid\b/i.test(userAgent) && (isTikTokUserAgent || (isAndroidWebView && isTikTokReferrer));
  const state = {
    active: isTikTokAndroid,
    linkCount: 0,
    ref: "tiktok_halloween_2026"
  };

  window.MORAEA_HALLOWEEN_TIKTOK_STATE = state;
  document.documentElement.dataset.moraeaTiktokBridge = isTikTokAndroid ? "intent-v2" : "inactive";
  if (!isTikTokAndroid) return;

  function buildIntentUrl(target) {
    const url = new URL(target, window.location.origin);
    const destination = `${url.pathname}${url.search}${url.hash}`;
    return `intent://${url.host}${destination}#Intent;scheme=${url.protocol.replace(":", "")};action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;S.browser_fallback_url=${encodeURIComponent(url.href)};end`;
  }

  function isSameDocumentHash(url) {
    return Boolean(url.hash) && url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search;
  }

  function rewriteLink(link) {
    if (!(link instanceof HTMLAnchorElement) || link.hasAttribute("data-moraea-no-intent")) return;
    const current = link.getAttribute("href") || "";
    if (!link.dataset.moraeaTiktokDestination) {
      if (!current || current.startsWith("#") || current.startsWith("intent:") || current.startsWith("mailto:") || current.startsWith("tel:") || current.startsWith("javascript:")) return;
      link.dataset.moraeaTiktokDestination = current;
    }
    let destination;
    try {
      destination = new URL(link.dataset.moraeaTiktokDestination, window.location.href);
    } catch {
      return;
    }
    if (!/^https?:$/.test(destination.protocol) || isSameDocumentHash(destination)) return;
    const intent = buildIntentUrl(destination.href);
    if (link.getAttribute("href") !== intent) link.setAttribute("href", intent);
    link.removeAttribute("target");
    link.dataset.moraeaTiktokIntentV2 = "true";
  }

  function refreshLinks(scope = document) {
    if (scope instanceof HTMLAnchorElement) rewriteLink(scope);
    if (scope.querySelectorAll) scope.querySelectorAll("a[href]").forEach(rewriteLink);
    state.linkCount = document.querySelectorAll('a[data-moraea-tiktok-intent-v2="true"]').length;
  }

  refreshLinks();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes") rewriteLink(mutation.target);
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) refreshLinks(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["href", "target"]
  });
})();
